import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationPT from "./locales/pt/url.json";
import translationEN from "./locales/en/url.json";
import translationPL from "./locales/pl/url.json";
import translationES from "./locales/es/url.json";

// the translations "pt", "gb", "us", "es", "de", "it", "pl", "ro", "ru", "tr"
const resources = {
  pt: {
    translation: translationPT,
  },
  en: {
    translation: translationEN,
  },
  pl: {
    translation: translationPL,
  },
  es: {
    translation: translationES,
  },
};

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    supportedLngs: ["pt", "en", "es", "fr", "pl"],
    nonExplicitSupportedLngs: false,
    fallbackLng: "en",
    // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
